import React, { Fragment, useState } from 'react';
import { SvgIcon, Button, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import DateIssuedIcon from '../../../../icons/dateIssued.svg?react';
import ButtonCardWithFunction from '../../../Helpers/Buttons/ButtonCardWithFunction';
import TermLengthCalculator from './TermLengthCalculator';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import './TermLengthStackedButton.scss';

export default function TermLengthStackedButton(props) {

  const shape = props.shape ? props.shape : 'wide';

  const title = props.title || "NEEDS ANALYSIS";
  const toolName = props.toolName;
  const icon = props.icon || <SvgIcon component={DateIssuedIcon} />;

  const [modalTermLengthCalculatorIsOpen, setModalTermLengthCalculatorIsOpen] = useState(false);

  const modalTermLengthCalculatorFields = {
    modalTermLengthCalculatorIsOpen: modalTermLengthCalculatorIsOpen,
    setModalTermLengthCalculatorIsOpen: setModalTermLengthCalculatorIsOpen,
    insuredAge: props.insuredAge
  };

  const redirectToTermLength = () => {
    setModalTermLengthCalculatorIsOpen(true);
  };

  const handleToolTip = (e) => {
    e.stopPropagation();
  };

  return (
    <Fragment>
      {props.condensed
        ?
        <div className="terms-analysis-basic-button" style={{'--lighter-off-white': 'rgba(0, 0, 0, 0.01)'}}>
          <Button type="button"
            onClick={() => setModalTermLengthCalculatorIsOpen(true)}
            variant={props.isPrequote ? undefined : "contained"}
            color="primary"
            className={`${`quote-terms-button button-primary`}`}
          >
            {toolName}
            <span className="help-container" onClick={handleToolTip}>
              <Tooltip title={props.title} enterTouchDelay={0}
                slotProps={{
                  tooltip: {
                    className: 'light-tooltip',
                    sx: { fontSize: '11px' }
                  },
                }}>
                <InfoOutlinedIcon className='help-tooltip' fontSize="small" />
              </Tooltip>
            </span>
          </Button>
        </div>
        :
        <div className="terms-analysis-stacked-button" style={{'--lighter-off-white': 'rgba(0, 0, 0, 0.01)'}}>
          {props.type === "quote-screen" ?
            <Button type="submit"
              onClick={() => setModalTermLengthCalculatorIsOpen(true)}
              variant={props.isPrequote ? undefined : "contained"}
              color="primary"
              className={`${`quote-terms-button button-primary`}`}
            >
              {props.isPrequote ? <SvgIcon component={DateIssuedIcon} color="primary" /> :
                <div className={`icon-container mb-0 lightBackground`}><SvgIcon component={DateIssuedIcon} color="primary" /></div>}
              <h3 className="tool-name">{toolName}</h3>
              <span className="name">&nbsp;{title}</span>
            </Button>
            :
            <ButtonCardWithFunction id={0}
              name={title}
              onClick={redirectToTermLength}
              shape={shape}
              icon={icon}
              className="button-primary"
              isFromHomePage={props.isFromHomePage}
            />
          }
        </div>
      }
      <TermLengthCalculator
        fields={modalTermLengthCalculatorFields}
        onTermLengthCalculation={props.onTermLengthCalculation}
        isPrequote={props.isPrequote}
        isCustomTerm={props.isCustomTerm}
      />
    </Fragment>
  );
}

TermLengthStackedButton.propTypes = {
  shape: PropTypes.string,
};
